import { paymentDataSources } from '@/Models';

export { reCaptchaActions } from '@/Types/ReCaptchaActions';

export const defaultPaymentMethod = { type: 'scheme' };

export const sectionTypes = {
    recent: 0,
    suggested: 1,
    other: 2,
};

export const redirectOrExternalFlowPaymentMethods = [
    paymentDataSources.klarnaPayNow,
    paymentDataSources.bancontactCard,
    paymentDataSources.ideal,
    paymentDataSources.bancontactMobile,
    paymentDataSources.payPal,
    paymentDataSources.blik,
    paymentDataSources.onlineBankingFI,
    paymentDataSources.onlineBankingPL,
    paymentDataSources.twint,
    paymentDataSources.eps,
    paymentDataSources.trustly,
    paymentDataSources.mobilePay,
];

export const paymentMethodsRequiringFormValidation = [
    paymentDataSources.klarnaPayNow,
    paymentDataSources.newCard,
    paymentDataSources.bancontactCard,
    paymentDataSources.blik,
    paymentDataSources.onlineBankingFI,
    paymentDataSources.onlineBankingPL,
    paymentDataSources.eps,
    paymentDataSources.trustly,
];
